import request from '@/utils/request'

export function selectPieceworkProcess(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/reckon/selectPieceworkProcess?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addPieceworkProcess(data) {
    return request({
        url: `api/serviceCenter/reckon/addPieceworkProcess`,
        method: 'post',
        data,
    })
}

export function upPieceworkProcess(data) {
    return request({
        url: `api/serviceCenter/reckon/upPieceworkProcess`,
        method: 'post',
        data,
    })
}

export function bathDeletePieceworkProcess(data) {
    return request({
        url: `api/serviceCenter/reckon/bathDeletePieceworkProcess`,
        method: 'post',
        data,
    })
}




export function selectPieceworkCount(data) {
    return request({
        url: `api/serviceCenter/reckon/selectPieceworkCount`,
        method: 'post',
        data,
    })
}

export function updatePieceworkProcess(data) {
    return request({
        url: `api/serviceCenter/orderManagement/updatePieceworkProcess`,
        method: 'post',
        data,
    })
}

export function bathDeletePieceworkCount(data) {
    return request({
        url: `api/serviceCenter/reckon/bathDeletePieceworkCount`,
        method: 'post',
        data,
    })
}

